import { Navigate, Route, Routes } from 'react-router-dom';
import AdminPage from '../pages/AdminPage';
import AdminDashboardPage from '../pages/AdminDashboardPage';
import ShowManagementPage from '../pages/ShowManagementPage';
import ShowResultsManagementPage from '../pages/ShowResultsManagementPage';
import ShowResultDetailsPage from '../pages/ShowResultDetailsPage';
import StandingsManagementPage from '../pages/StandingsManagementPage';

export const PrivateRoutes = () => {
  return (
    <Routes>
      {/* Private/Authenticated Routes */}
      <Route path="/" element={<AdminPage />} />
      <Route path="/dashboard" element={<AdminDashboardPage />} />
      <Route path="/showManagement" element={<ShowManagementPage />} />
      <Route path="/showResultsManagement" element={<ShowResultsManagementPage />} />
      <Route path="/showResultsManagement/:showId" element={<ShowResultDetailsPage />} />
      <Route path="/standingsManagement" element={<StandingsManagementPage />} />
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
};
